<template>
  <div class="layout">
      <h1>{{ name }}会员服务协议</h1>
      <article>
        <p>重要须知</p>
        <p>{{name}}在此特别提醒用户（或称"您"）仔细阅读（未成年人应在其法定监护人的陪同下阅读）本《{{name}}会员服务协议》（下称"本协议"）中的各个条款，包括但不限于免除或者限制{{name}}责任的条款、对用户权利进行限制的条款以及约定争议解决方式、司法管辖的条款。用户有权选择同意或者不同意本协议。</p>
        <p>{{name}}会员服务是有偿的增值服务，您必须完全同意下列所有服务条款并完成付费，才能享受相关服务。您如果通过会员开通页面购买{{name}}会员服务， 即视为完全同意本协议，愿意接受本协议所有条款的约束。</p>
        <ol>
          <li>
            <h3>1. 总则</h3>
            <p>1.1 {{name}}用户是指完成全部注册流程，愿意接受{{name}}用户协议并在{{name}}相关使用规范的规定下使用{{name}}服务的注册用户。</p>
            <p>1.2 {{name}}会员服务是{{name}}为{{name}}用户提供的有偿增值服务，用户向{{name}}支付相关费用后，方可享受专门为会员提供的各项服务。</p>
            <p>1.3 {{name}}将为会员提供多种专有的增值会员服务。</p>
            <p>1.4 {{name}}有权根据实际情况随时调整服务内容。</p>
          </li>
          <li>
            <h3>2. 协议目的</h3>
            <p>本协议旨在约定用户在试用、购买、使用、终止{{name}}会员服务的过程中与{{name}}双方分别作为本协议的一方合同当事人所享有的权利和所负有的义务。</p>
          </li>
          <li>
            <h3>3. 服务的开通和终止</h3>
            <p>3.1 {{name}}用户完成实名认证和会员费用的支付，即可成为{{name}}会员。</p>
            <p>3.2 会员有效期自{{name}}会员服务开通之时起算起，具体有效期时间可以登录{{name}}会员在会员页查看。</p>
            <p>3.3 会员有效期过期后，{{name}}将终止提供会员增值服务。</p>
            <p>3.4 会员资费将在{{name}}会员服务开通页面显示，{{name}}将根据用户购买方式和数量的不同提供不同幅度的优惠，具体优惠信息以会员支付页上内容为准。</p>
            <p>3.5 {{name}}有权根据实际情况随时调整费用标准，并在约定之日起生效。在约定日期前按原资费标准购买服务的用户，其会员资格及服务在资费调整前购买的期限内不受影响 ，且无需补充缴纳差额；在约定日期后进行支付，购买会员服务的用户，应按照更新后的资费标准进行支付。</p>
            <p>3.6 由于实名认证的需要，会员在会员有效期内解除、修改绑定手机号，可能会造成会员服务被终止。</p>
            <p>3.7 会员在会员有效期内续费，有效期将在原服务有效期基础上延长。</p>
            <p>3.8 会员应确保注册资料的真实性。如因注册信息不真实而引起的问题所带来的后果及责任，由用户自行承担。</p>
            <p>3.9 用户申请开通/试用{{name}}会员服务前，需完善个人的身份资料，包含但不限于手机号、地址、邮箱、性别等信息并保证信息的真实、准确、完整、合法有效、如有变动、应及时更新。如因用户个人资料的不合法、不真实、不准确、不详尽等原因造成法律风险或损失，相关责任及后果由用户自行承担。</p>
            <p>3.10 会员在付费的有效期内享受{{name}}会员的各项增值服务。</p>
          </li>
          <li>
            <h3>4. 会员的权利与义务</h3>
            <p>4.1 会员可优先参加由{{name}}组织的活动并享受对应的优惠及增值服务。</p>
            <p>4.2 会员有权利不参加{{name}}组织的任何活动。</p>
            <p>4.3 会员在会员有效期内可主动终止或取消会员资格，但不获得剩余有效期会员费用的退还。</p>
            <p>4.4 会员自行承担在{{name}}中发布、传播信息的法律责任，会员使用{{name}}服务，包括免费服务与增值服务的行为，均应遵守中华人民共和国的各项法律法规。</p>
            <p>4.5 开通/试用{{name}}会员服务后，用户需要确保账户仅限本人合理合规使用，并不得进行任何损害{{name}}或其他用户合法权益的行为，若用户出现不合理不合规使用{{name}}会员服务的行为，{{name}}有权采取相应处理措施，包括但不限于：暂停或取消用户的会员身份、冻结或取消用户账号等。</p>
          </li>
          <li>
            <h3>5. {{name}}的权利和义务</h3>
            <p>5.1 {{name}}有义务保证会员服务的顺畅，当出现技术故障导致会员服务提供有碍时，{{name}}应尽快排除故障。</p>
            <p>5.2 {{name}}在未经会员授权时不得公开、编辑或透露会员注册及保存的非公开内容。法律规定的情形除外。</p>
            <p>5.3 {{name}}通过{{name}}系统通知、短信通知、邮箱通知等多种方式对会员进行通知和公告。</p>
            <p>5.4 因不可抗力造成会员服务的中断或其它缺陷，{{name}}不承担任何责任，但将尽力减少因此给会员造成的损失和影响。</p>
            <p>5.5 因用户原因造成{{name}}账号密码泄露，{{name}}不承担责任，同时为避免{{name}}账号被盗用后滥用而引起法律风险，{{name}}有权在知悉该情形后采取一切措施避免第三方对用户的会员帐号实施操作行为，而不论其基于何种目的、获取方式是否善意合法。</p>
            <p>5.6 若会员在使用{{name}}服务或{{name}}会员服务的过程中，故意进行有损{{name}}、{{name}}用户或会员合法权益的行为，{{name}}有权取消该会员的会员资格而无需给予任何补偿，并保留进一步追究该行为法律责任的权利。</p>
            <p>5.7 若会员在使用{{name}}服务或{{name}}会员服务的过程中，存在触犯中华人民共和国法律法规的行为，{{name}}有权取消该会员的会员资格而无须给与任何补偿，行为人须自行承担全部责任。</p>
          </li>
          <li>
            <h3>6. 其他</h3>
            <p>6.1 本服务条款的解释，效力及纠纷的解决，适用于中华人民共和国大陆法律。</p>
            <p>6.2 {{name}}可依照{{name}}发展的不同阶段，出于维护{{name}}会员秩序的目的，不断完善本条款。</p>
            <p>6.3 用户如果对本协议有任何疑问或者异议的，可以反馈至用户QQ群：638920741 中的官方客服人员，{{name}}团队将及时解决您的问题。一般情况下，将在三十天内回复您的邮件。</p>
          </li>
        </ol>
      </article>
  </div>
</template>
<script>
export default {
  data () {
    return {
      name: ''
    }
  },
  created() {
    // if(typeof(window.android) !== "object"){
    // 上面的写法无法区分 null 2020-04-11 调整
    if (!window.android) {
      this.name = '隐私云空间'
    } else {
      var android = window.android
      this.name = android.getApkName()
    }
  },
}
</script>
<style scoped>
  h1 {
    text-align: center;
  }
  article > p {
    padding: .6em 0;
  }
  h3 {
    font-size: 1.3em;
    font-weight: 700;
    padding: .6em 0;
  }
  h4 {
    font-weight: 700;
    padding: .6em 0;
  }
  li > span,
  p > span {
    font-weight: 700;
  }
  li > p {
    padding: .4em 0;
  } 
  li {
    padding: .5em 0;
  }
  .layout {
    padding: 1em 4%;
    letter-spacing: .5px;
  }
  .title {
    font-size: 1.4em;
    font-weight: 700;
    margin-bottom: 1em;
    text-align: center;
  }
  .sub_list > * {
    padding: .6em 0;
    font-size: .9em;
  }
  strong {
    font-weight: 700;
  }
</style>